import { Button } from "@/shared/components/ui/button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { inviteService } from "@/shared/services/api/invite";
import { ROUTES } from "@/core/router/routes";
import { getDashboardLink } from "@/shared/utils/link";

interface AuthInviteContentProps {
  invitationMessage: string;
  toEmail: string;
  shareLinkHash: string;
  successMessage: string;
}

export default function AuthInviteContent({
  invitationMessage,
  toEmail,
  shareLinkHash,
  successMessage,
}: AuthInviteContentProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleAccept = async () => {
    if (!shareLinkHash) return;

    setIsLoading(true);
    setError(false);

    try {
      const response = await inviteService.acceptWorkspaceInvite(shareLinkHash);

      if (response.success) {
        setSuccess(true);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoToDashboard = () => {
    navigate(`/${ROUTES.Dashboard.Root}`);
  };

  const handleGoToMySpecs = () => {
    navigate(getDashboardLink(ROUTES.Dashboard.MySpecs.Root));
  };

  // Success state
  if (success) {
    return (
      <div className="auth-page-container flex items-center flex-col w-[395px]">
        <h3 className="text-[24px] leading-[32px] tracking-[-0.015em] font-[700] text-[#09090B] mb-[12px] text-center">
          {successMessage}
        </h3>
        <div className="w-full flex flex-col items-center justify-center mt-8">
          <Button variant="success" onClick={handleGoToMySpecs}>
            Şartnamelerime Git
          </Button>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="auth-page-container flex items-center flex-col w-[395px]">
        <h3 className="text-[24px] leading-[32px] tracking-[-0.015em] font-[700] text-[#09090B] mb-[12px] text-center">
          Daveti kabul ederken bir sorun yaşandı
        </h3>
        <div className="w-full flex flex-col items-center justify-center mt-8">
          <Button variant="success" onClick={handleGoToDashboard}>
            Dashboard'a Git
          </Button>
        </div>
      </div>
    );
  }

  // Default state
  return (
    <div className="auth-page-container flex items-center flex-col w-[395px]">
      {/* Invitation message */}
      <h3 className="text-[24px] leading-[32px] tracking-[-0.015em] font-[700] text-[#09090B] mb-[12px] text-center">
        {invitationMessage}
      </h3>

      {/* Info message */}
      <div className="text-[16px] font-400 leading-[24px] mb-[24px] text-center text-muted-foreground">
        Daveti kabul ederek erişim sağlayabilirsin.
      </div>

      {/* Accept button */}
      <div className="w-full flex flex-col items-center justify-center">
        <Button
          variant="success"
          onClick={handleAccept}
          isLoading={isLoading}
          disabled={isLoading}
        >
          Accept
        </Button>
      </div>
    </div>
  );
}
